<script setup>
/**
 * What the subscription puts on the phone, as the phone really draws it: two
 * crops of the iOS simulator running Follow, not a mock. The lock-screen Live
 * Activity, with the compact Dynamic Island centred above it, the way the top
 * of the phone shows it. Still pictures, no motion, so reduced motion needs no rule.
 * Decorative: the headline and benefit rows say the same in words.
 */
import islandUrl from '../assets/paywall/island-compact.webp';
import lockUrl from '../assets/paywall/lock.webp';
</script>

<template>
  <div class="proof" data-testid="paywall-proof" aria-hidden="true">
    <img class="island" :src="islandUrl" alt="" width="583" height="110" decoding="async">
    <img class="lock" :src="lockUrl" alt="" width="900" height="336" decoding="async">
  </div>
</template>

<style scoped>
/* The compact island sits centred above the card with a small gap, so nothing
   on the card is covered. Both crops are already rounded (alpha), so the
   shadow follows their shape. */
.proof {
  --proof-shadow: drop-shadow(0 4px 8px rgb(0 0 0 / 0.22)) drop-shadow(0 1px 2px rgb(0 0 0 / 0.12));
  width: min(100%, 300px);
  margin: 14px auto 12px;
}
/* Dark: both crops are near-black on a near-black sheet, so each gets a soft
   light rim and a faint glow to lift it off the page, plus the usual shadow. */
:root[data-scheme='dark'] .proof {
  --proof-shadow: drop-shadow(0 0 0.75px rgb(255 255 255 / 0.55)) drop-shadow(0 0 10px rgb(140 190 255 / 0.12)) drop-shadow(0 6px 12px rgb(0 0 0 / 0.6));
}

.proof img {
  display: block;
  height: auto;
  filter: var(--proof-shadow);
}
.island {
  width: 44%;
  margin: 0 auto 8px;
}
.lock {
  width: 100%;
}

@media (max-height: 740px) {
  .proof { width: min(100%, 196px); margin: 9px auto 7px; }
  .island { margin-bottom: 5px; }
}
</style>
